/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Blocked_No_Tax_CountryInputs */



/**
* | output |
* | --- |
* | "No tax country on this partner, so no credit note can be drafted until it is set." |
*
* @param {Partner_Admin_Commission_Blocked_No_Tax_CountryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_blocked_no_tax_country = /** @type {((inputs?: Partner_Admin_Commission_Blocked_No_Tax_CountryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Blocked_No_Tax_CountryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Steuerland bei diesem Partner, daher kann bis zur Erfassung keine Gutschrift erstellt werden.")
	return /** @type {LocalizedString} */ ("No tax country on this partner, so no credit note can be drafted until it is set.")
});